// @core/api/endpoints/billing/create_billing_policy.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  BillingPolicyResponse,
  CreateBillingPolicyRequest,
} from '../../../types/billing';

const BASE_PATH = '/billing';

/**
 * Create billing policy
 * Creates a billing policy for a scope entity (organization, department, team). Configures default payment terms, currency, tax rates, and invoice behavior.
 */
export async function CreateBillingPolicy(
  data: CreateBillingPolicyRequest,
  options?: RequestOptions
): Promise<BillingPolicyResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/billing-policies`;
  const requestOptions = options;
  return client.post<BillingPolicyResponse>(requestPath, data, requestOptions);
}
